module.exports = __webpack_public_path__ + "static/logo_tinaba_bianco_orizzontale-bd725aa70e55e2563e32814d6183c224.png";